// src/pages/processifyd/ProcessifydOneView.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus, faEdit, faTrash, faFolderOpen, faSearch, faTimes,
  faChevronLeft, faChevronRight, faDownload, faShare, faComment,
  faHistory, faCamera, faMapMarkerAlt, faQrcode, faSms, faEnvelope,
  faPhone, faUndo, faUserPlus, faExclamationTriangle, faPrint
} from "@fortawesome/free-solid-svg-icons";
import SampleCSAT from "./components/SampleCSAT";
import EmptyProcess from "./components/EmptyProcess";

const ProcessifydOneView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");
  const [selectedProcess, setSelectedProcess] = useState("CSAT Sample");
  const [showData, setShowData] = useState(true); // Default shows CSAT Sample

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  // CSAT Sample Data
  const csatData = {
    csatID: "2312001",
    title: "Help",
    currentState: "CSAT Report Prepared",
    objective: "To measure customer satisfaction after service interaction and identify improvement areas",
    scope: "All customers who received service in the last 30 days",
    raci: "Business Team (R), Process Analyst (A), IT Team (C), Compliance (I)",
    periodFrom: "01 Jan 2024",
    periodTo: "31 Mar 2024",
    population: "12,450",
    department: "Customer Experience",
    sampleSize: "1,245",
    owner: "Sanjeev Kumar",
    samplingMethod: "Random Stratified Sampling",
    newness: "First Time",
    cost: "$2,450",
    previousCSATID: "2311008",
    product: "Personal Loan",
    category: "Service Delivery",
    subCategory: "Post Disbursement Support",
    remarks: "High importance - Linked to NPS improvement initiative",
  };

  // Full Action History
  const actionHistory = [
    { sn: 1, from: "Survey Archival in Progress", to: "Survey Archival Finished", date: "15 Mar 2024 14:32", type: "A", by: "Sanjeev Kumar", comment: "" },
    { sn: 2, from: "Survey Archival Initiated", to: "Survey Archival in Progress", date: "14 Mar 2024 09:15", type: "", by: "Priya Sharma", comment: "" },
    { sn: 3, from: "Survey Campaign End of Life", to: "Survey Archival Initiated", date: "12 Mar 2024 18:45", type: "A", by: "System", comment: "" },
    { sn: 4, from: "Program Evaluation Done", to: "Survey Campaign End of Life", date: "11 Mar 2024 16:20", type: "A", by: "Sanjeev Kumar", comment: "" },
    { sn: 8, from: "Program Evaluation in Progress", to: "Program Evaluation Done", date: "07 Mar 2024 14:55", type: "A", by: "Priya Sharma", comment: "" },
    { sn: 9, from: "Program Evaluation Initiated", to: "Program Evaluation in Progress", date: "06 Mar 2024 09:00", type: "A", by: "Sanjeev Kumar", comment: "" },
    { sn: 10, from: "Next Repeat Survey Defined", to: "Program Evaluation Initiated", date: "05 Mar 2024 17:20", type: "A", by: "System", comment: "" },
    { sn: 11, from: "Business Review Finished", to: "Next Repeat Survey Defined", date: "04 Mar 2024 11:10", type: "A", by: "Sanjeev Kumar", comment: "" },
    { sn: 13, from: "Business Review in Progress", to: "Business Review Finished", date: "02 Mar 2024 10:25", type: "A", by: "Priya Sharma", comment: "" },
    { sn: 14, from: "Business Review Initiated", to: "Business Review in Progress", date: "01 Mar 2024 08:50", type: "A", by: "Sanjeev Kumar", comment: "" },
    { sn: 15, from: "Audit and Compliance Check Finished", to: "Business Review Initiated", date: "28 Feb 2024 16:15", type: "A", by: "Compliance Team", comment: "" },
    { sn: 18, from: "Audit and Compliance in Progress", to: "Audit and Compliance Check Finished", date: "25 Feb 2024 09:45", type: "A", by: "Sanjeev Kumar", comment: "" },
    { sn: 19, from: "Audit and Compliance Activity Initiated", to: "Audit and Compliance in Progress", date: "24 Feb 2024 11:20", type: "A", by: "Priya Sharma", comment: "" },
    { sn: 27, from: "CAPA Monitoring in Progress", to: "Audit and Compliance Activity Initiated", date: "16 Feb 2024 10:05", type: "A", by: "Sanjeev Kumar", comment: "" },
    { sn: 28, from: "CAPA Monitoring Initiated", to: "CAPA Monitoring in Progress", date: "15 Feb 2024 14:50", type: "A", by: "System", comment: "" },
    { sn: 29, from: "CAPA Done", to: "CAPA Monitoring Initiated", date: "14 Feb 2024 09:30", type: "A", by: "Compliance Team", comment: "" },
    { sn: 30, from: "CAPA Implementation in Progress", to: "CAPA Done", date: "13 Feb 2024 16:40", type: "", by: "Sanjeev Kumar", comment: "" },
    { sn: 31, from: "CAPA Responsibilities Assigned", to: "CAPA Implementation in Progress", date: "12 Feb 2024 11:00", type: "A", by: "Sanjeev Kumar", comment: "" },
    { sn: 37, from: "CAPA Planning", to: "CAPA Responsibilities Assigned", date: "08 Feb 2024 13:25", type: "A", by: "Priya Sharma", comment: "" },
    { sn: 38, from: "Retrospective Analysis Finished", to: "CAPA Planning", date: "07 Feb 2024 09:40", type: "A", by: "System", comment: "" },
    { sn: 39, from: "Retrospective Analysis in Progress", to: "Retrospective Analysis Finished", date: "06 Feb 2024 15:10", type: "A", by: "Sanjeev Kumar", comment: "" },
    { sn: 40, from: "Retrospective Analysis Initiated", to: "Retrospective Analysis in Progress", date: "05 Feb 2024 10:30", type: "A", by: "Priya Sharma", comment: "" },
    { sn: 46, from: "CSAT Report Feedback Taking in Progress", to: "CSAT Report Feedback Taking Done", date: "25 Jan 2024 14:20", type: "A", by: "Sanjeev Kumar", comment: "" },
    { sn: 47, from: "CSAT Report Feedback Taking Initiated", to: "CSAT Report Feedback Taking in Progress", date: "24 Jan 2024 09:15", type: "A", by: "System", comment: "" },
    { sn: 48, from: "CSAT Report Distributed", to: "CSAT Report Feedback Taking Initiated", date: "23 Jan 2024 16:50", type: "A", by: "Sanjeev Kumar", comment: "" },
    { sn: 49, from: "CSAT Report Distribution List Preparation", to: "CSAT Report Distributed", date: "22 Jan 2024 11:30", type: "A", by: "Priya Sharma", comment: "" },
    { sn: 50, from: "CSAT Report Finished", to: "CSAT Report Distribution List Preparation", date: "21 Jan 2024 13:45", type: "A", by: "System", comment: "" },
    { sn: 51, from: "CSAT Report compilation in Progress", to: "CSAT Report Finished", date: "20 Jan 2024 10:00", type: "A", by: "Sanjeev Kumar", comment: "" },
    { sn: 52, from: "CSAT Report Initiated", to: "CSAT Report compilation in Progress", date: "19 Jan 2024 08:30", type: "A", by: "Priya Sharma", comment: "" },
    { sn: 69, from: "Feedback Collection Finished", to: "Feedback Analysis Initiated", date: "10 Jan 2024 12:00", type: "A", by: "System", comment: "" },
    { sn: 70, from: "Feedback Validated", to: "Feedback Collection Finished", date: "09 Jan 2024 14:35", type: "A", by: "Sanjeev Kumar", comment: "" },
    { sn: 75, from: "Feedback Collection in Progress", to: "New Feedback Received", date: "05 Jan 2024 09:20", type: "A", by: "System", comment: "" },
    { sn: 76, from: "Survey Distribution Finished", to: "Feedback Collection in Progress", date: "04 Jan 2024 16:10", type: "A", by: "Priya Sharma", comment: "" },
    { sn: 82, from: "Survey Distribution Initiated", to: "Survey Distribution in Progress", date: "02 Jan 2024 08:00", type: "A", by: "Sanjeev Kumar", comment: "" },
    { sn: 83, from: "New Survey Created", to: "Survey Distribution Initiated", date: "01 Jan 2024 10:30", type: "A", by: "System", comment: "CSAT Journey Started" },
  ];

  const questionnaire = [
    { qn: "Q1", question: "How satisfied are you with our service?", answerType: "Rating (1-5)", options: "1-Poor to 5-Excellent" },
    { qn: "Q2", question: "Would you recommend us to others?", answerType: "NPS", options: "0-10 Scale" },
    { qn: "Q3", question: "Any additional comments?", answerType: "Text", options: "" },
  ];

  const handleShow = () => {
    setShowData(true);
    // In future, when backend is integrated, you can fetch data based on selectedProcess here
  };

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 p-4 md:p-6">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-black border-b border-blue-500/40 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-2xl font-bold text-cyan-300">Processifyd One-View</div>
        </div>

        <div className="hidden md:flex items-center gap-4">
          {isLoggedIn && (
            <>
              <span className="text-xs text-teal-300">{userName}</span>
              <button onClick={handleLogout} className="w-12 px-2 py-1 bg-red-700/80 hover:bg-red-600 rounded-md text-sm">⏻</button>
            </>
          )}
        </div>

        <button className="md:hidden text-2xl text-cyan-300" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      <div className="min-h-[75vh]">
        {/* Process Selector */}
        <div className="mt-6 bg-gray-800 border border-gray-700 rounded-xl p-4 flex flex-col sm:flex-row gap-4 items-end">
          <div className="flex-1 w-full">
            <label className="block text-xs text-gray-400 mb-1">Select Process</label>
            {/* <select
              value={selectedProcess}
              onChange={(e) => setSelectedProcess(e.target.value)}
              className="w-full bg-gray-900 border border-gray-600 rounded-lg px-4 py-3 text-white focus:border-cyan-500 outline-none"
            >
              <option value="CSAT Sample">CSAT Sample</option>
            </select> */}
            <select
                value={selectedProcess}
                onChange={(e) => setSelectedProcess(e.target.value)}
                className="w-full h-12 bg-gray-900 border border-gray-600 rounded-lg px-4 py-3 text-white"
                >
                <option value="CSAT Sample">CSAT Sample</option>
                <option value="Audit Process">Audit Process</option>
                <option value="Complaint Management">Complaint Management</option>
            </select>
          </div>
          <button
            onClick={handleShow}
            className="w-full sm:w-auto px-8 py-3 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium flex items-center justify-center gap-2"
          >
            Show
          </button>
        </div>

        {/* Current State Info Bar */}
        {showData && (
          <div className="mt-6 bg-gray-800 border border-gray-700 rounded-2xl p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div>
                <div className="text-xs text-gray-400">Current State</div>
                <div className="text-xl font-semibold text-emerald-400">{csatData.currentState}</div>
              </div>
              <div>
                <div className="text-xs text-gray-400">Title</div>
                <div className="font-semibold text-lg">{csatData.title}</div>
              </div>
              <div>
                <div className="text-xs text-gray-400">Owner</div>
                <div className="font-medium">{csatData.owner}</div>
              </div>
              <div>
                <div className="text-xs text-gray-400">Period</div>
                <div className="font-medium">{csatData.periodFrom} to {csatData.periodTo}</div>
              </div>
            </div>
          </div>
        )}

        {/* Tabs */}
        <div className="mt-8 flex border-b border-gray-700 overflow-x-auto">
          {["overview", "questionnaire", "responses", "history", "actions"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-6 py-4 font-medium border-b-2 transition-colors whitespace-nowrap ${
                activeTab === tab ? "border-cyan-400 text-cyan-300" : "border-transparent text-gray-400 hover:text-gray-200"
              }`}
            >
              {tab === "overview" && "Survey Details"}
              {tab === "questionnaire" && "Questionnaire"}
              {tab === "responses" && "Survey Participants"}
              {tab === "history" && "Action History"}
              {tab === "actions" && "Quick Actions"}
            </button>
          ))}
        </div>

        {/* Tab Contents */}
        <div className="mt-8">
          {/* Overview Tab */}
          {/* {activeTab === "overview" && showData && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div className="bg-gray-800 border border-gray-700 rounded-2xl p-8">
                <h3 className="text-cyan-300 text-lg font-semibold mb-6">Survey Details</h3>
                <div className="grid grid-cols-2 gap-y-6 text-sm">
                  <div className="text-gray-400">Objective</div><div>{csatData.objective}</div>
                  <div className="text-gray-400">Scope</div><div>{csatData.scope}</div>
                  <div className="text-gray-400">RACI</div><div>{csatData.raci}</div>
                  <div className="text-gray-400">Population</div><div>{csatData.population}</div>
                  <div className="text-gray-400">Sample Size</div><div>{csatData.sampleSize}</div>
                  <div className="text-gray-400">Department</div><div>{csatData.department}</div>
                  <div className="text-gray-400">Sampling Method</div><div>{csatData.samplingMethod}</div>
                  <div className="text-gray-400">Newness</div><div className="text-emerald-400">{csatData.newness}</div>
                  <div className="text-gray-400">Cost</div><div className="text-emerald-400">${csatData.cost}</div>
                </div>
              </div>
              <div className="bg-gray-800 border border-gray-700 rounded-2xl p-8">
                <h3 className="text-cyan-300 text-lg font-semibold mb-6">Product / Service Details</h3>
                <div className="space-y-4">
                  <div><strong>Product:</strong> {csatData.product}</div>
                  <div><strong>Category:</strong> {csatData.category}</div>
                  <div><strong>Sub-Category:</strong> {csatData.subCategory}</div>
                  <div><strong>Remarks:</strong> {csatData.remarks}</div>
                </div>
              </div>
            </div>
          )} */}
          {activeTab === "overview" && showData && (
            <>
                {selectedProcess === "CSAT Sample" ? (
                <SampleCSAT data={csatData} />
                ) : (
                <EmptyProcess />
                )}
            </>
          )}

          {/* Questionnaire Tab */}
          {activeTab === "questionnaire" && showData && (
            <div className="bg-gray-800 border border-gray-700 rounded-2xl p-8">
              <h3 className="text-xl font-semibold text-cyan-300 mb-6">CSAT Questionnaire</h3>
              {/* Questionnaire Table - Same as previous version */}
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-gray-700">
                      <th className="text-left py-4 px-4">QN</th>
                      <th className="text-left py-4 px-4">Question</th>
                      <th className="text-left py-4 px-4">Answer Type</th>
                      <th className="text-left py-4 px-4">Options</th>
                    </tr>
                  </thead>
                  <tbody>
                    {questionnaire.map((q, i) => (
                      <tr key={i} className="border-b border-gray-700 hover:bg-gray-750">
                        <td className="py-4 px-4 font-mono text-cyan-300">{q.qn}</td>
                        <td className="py-4 px-4">{q.question}</td>
                        <td className="py-4 px-4 text-emerald-400">{q.answerType}</td>
                        <td className="py-4 px-4 text-gray-400">{q.options}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Action History Tab */}
          {activeTab === "history" && showData && (
            <div className="bg-gray-800 border border-gray-700 rounded-2xl p-8">
              <h3 className="text-xl font-semibold text-cyan-300 mb-6">CSAT Action History</h3>
              <div className="overflow-x-auto max-h-[620px]">
                <table className="w-full text-sm">
                  <thead className="sticky top-0 bg-gray-800">
                    <tr className="border-b border-gray-700">
                      <th className="text-left py-4 px-4">SN</th>
                      <th className="text-left py-4 px-4">From State</th>
                      <th className="text-left py-4 px-4">To State</th>
                      <th className="text-left py-4 px-4">Date & Time</th>
                      <th className="text-left py-4 px-4">Type</th>
                      <th className="text-left py-4 px-4">By</th>
                      <th className="text-left py-4 px-4">Comment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {actionHistory.map((log) => (
                      <tr key={log.sn} className="border-b border-gray-700 hover:bg-gray-750">
                        <td className="py-4 px-4">{log.sn}</td>
                        <td className="py-4 px-4 text-gray-400">{log.from}</td>
                        <td className="py-4 px-4 text-emerald-400">{log.to}</td>
                        <td className="py-4 px-4 text-gray-400">{log.date}</td>
                        <td className="py-4 px-4">{log.type}</td>
                        <td className="py-4 px-4">{log.by}</td>
                        <td className="py-4 px-4 text-gray-300">{log.comment}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Quick Actions Tab */}
          {activeTab === "actions" && showData && (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
              {[
                "Change Status", "Add Comment", "Add Variable", "Capture Media",
                "Capture Location", "Scan Tracker Code", "Send SMS", "Send Email",
                "Chat", "Call", "Rollback", "Assign", "Escalate", "Hot Alert",
                "Anticipate Legal", "Missed Deadline", "Export", "Print"
              ].map((action, i) => (
                <button
                  key={i}
                  className="bg-gray-800 hover:bg-gray-700 border border-gray-700 hover:border-cyan-500 h-28 rounded-2xl flex flex-col items-center justify-center gap-3 transition-all group"
                >
                  <span className="text-2xl text-cyan-400 group-hover:text-white">
                    {action.includes("Send") ? "✉" : action.includes("Capture") ? "📸" : "⚡"}
                  </span>
                  <span className="text-sm font-medium text-center px-2">{action}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-black border-t border-blue-400 text-white py-4 mt-16">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <a href="/about-us" className="hover:text-teal-300">About</a>
            <a href="/privacy-policy" className="hover:text-teal-300">Privacy Policy</a>
            <a href="/terms-of-use" className="hover:text-teal-300">Terms of Use</a>
            <a href="/contact-us" className="hover:text-teal-300">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ProcessifydOneView;